.navigation {
  display: flex;
  z-index: 1000;
  position: fixed;
  right: 1.375rem;
  bottom: 1.375rem;
  left: 1.375rem;
  justify-content: center;
  column-gap: 0.625rem;

  @media (min-width: 769px) {
    display: none;
  }

  &.actionsVisible {
    .add {
      .addIcon {
        transform: rotate(45deg);
      }

      .actions {
        opacity: 1;
        pointer-events: all;
        transform: none;
      }
    }

    .overlay {
      opacity: 1;
      pointer-events: all;
    }
  }

  .add,
  .links {
    height: 3.6875rem;
  }

  .links {
    display: flex;
    z-index: 100;
    justify-content: space-around;
    align-items: center;
    padding: 0.125rem 0.25rem;
    border-radius: 99rem;
    overflow: auto;
    direction: rtl;
    background-color: var(--neutral);
    box-shadow:
      0 0.625rem 1.125rem -0.25rem rgba(0, 0, 0, 0.1),
      0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
    scrollbar-width: none;

    .link {
      display: flex;
      position: relative;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 5.5rem;
      padding: 0.25rem 1.25rem;
      border: 0.0625rem solid transparent;
      border-radius: 99rem;
      outline: none;
      overflow: hidden;
      color: var(--neutral-600);
      background-color: transparent;

      &.active {
        border: 0.0625rem solid var(--primary-200);
        color: var(--primary-700);
        background-color: var(--primary-50);

        .indicator {
          border-color: var(--primary-50);
        }

        svg {
          color: var(--primary-700);
        }
      }

      svg {
        width: 1.375rem;
        height: 1.375rem;
        margin-top: 0.0625rem;
      }

      .label {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 0.125rem;
      }

      .indicator {
        display: none;
        position: absolute;
        top: 0.1875rem;
        left: calc(50% + 0.4375rem);
        width: 0.75rem;
        height: 0.75rem;
        border: 0.1875rem solid var(--neutral);
        border-radius: 10rem;
        background-color: var(--danger);
        transform: translateX(-50%);
      }
    }

    .userImage {
      width: 1.875rem;
      height: 1.875rem;
      margin-top: 0.0625rem;
      background: transparent;

      @media (min-width: 400px) {
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .add {
    z-index: 200;
    position: relative;
    flex: 0 0 auto;
    border-radius: 99rem;
    background: var(--primary-800);
    box-shadow:
      0.125rem 0.5rem 1rem -0.25rem rgba(0, 0, 0, 0.35),
      0.125rem 0.125rem 0.375rem rgba(0, 0, 0, 0.25);
    aspect-ratio: 1 / 1;

    .addIcon {
      display: flex;
      transition: transform 120ms ease-in-out;

      svg {
        width: 1.375rem;
        height: 1.375rem;
        color: var(--neutral);
      }
    }

    .actions {
      opacity: 0;
      position: absolute;
      right: 0;
      bottom: 4.5rem;
      flex-direction: column;
      align-items: flex-start;
      width: 10.75rem;
      padding: 0.25rem;
      border-radius: 1rem;
      overflow: hidden;
      pointer-events: none;
      background-color: var(--neutral);
      box-shadow: 0 0.125rem 0.375rem -0.1875rem
        rgba(var(--neutral-800-rgb), 0.3);
      transform: translateY(0.5rem);
      transition:
        transform 120ms ease-in-out,
        opacity 120ms ease-in-out;

      .button {
        width: 100%;
        height: 3rem;
        border-radius: 0.75rem;

        .buttonIcon {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calc(100% - 1rem);
          margin: 0 0 0 0.375rem;
          padding: 0.375rem;
          aspect-ratio: 1 / 1;

          svg {
            width: 1.375rem;
            height: 1.375rem;
          }
        }

        .buttonText {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 0 1rem 0 0.3125rem;
          row-gap: 0.0625rem;
        }
      }
    }
  }

  .overlay {
    opacity: 0;
    z-index: 150;
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    height: 15rem;
    border: none;
    outline: none;
    pointer-events: none;
    background: radial-gradient(
      150% 100% at 100% 100%,
      rgba(0, 0, 0, 0.25),
      transparent
    );
    box-shadow: none;
    transition: opacity 120ms ease-in-out;

    &:focus,
    &:active {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
}
